import 'locale-compare-polyfill'

import type { Locale } from '@libs/typescript-utils'

export default function localeCompareSort(a: string, b: string, locale: Locale = 'hu', options?: Intl.CollatorOptions) {
  return a === b ? 0 : a.localeCompare(b, locale, options)
}

export function orderCompanies<CompanyObject extends Pick<Company, 'name'>>(companies: CompanyObject[]) {
  return companies.sort((a, b) => localeCompareSort(a.name, b.name))
}
